import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { asStyledComponent } from '@cld/component-enhancer';
import { globalTheme } from '@cld/component-theme';
import { Label } from '../Label';

export interface InlineFieldLayoutProps {
  label?: ReactNode,
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  
  ${Label} {
    margin: 0;
    margin-left: ${globalTheme.spacing.xs};
  }
`;

/**
 * InlineFieldLayout is component that positions properly common form field elements - label and input control.
 * This is layout component only. In order to build a form field you need to place <em>Label</em> inside label region,
 * any input control as a child.
 */
export const InlineFieldLayout = asStyledComponent<FC<InlineFieldLayoutProps>>(({ label, children, ...rest }) => (
  <Wrapper {...rest}>
    {children}
    {label}
  </Wrapper>
));
